/**
 * <wishlist-button> — lightweight visual toggle for the product-card wishlist heart.
 *
 * This is a UI hook only. Per Shatkona_Project_Scope_v1 (section 6), the actual
 * wishlist persistence is provided by a third-party app (Wishlist King / Swym).
 * Once that app is installed, swap the two TODO lines below for that app's
 * JS API calls (both apps expose a small JS SDK for exactly this purpose).
 *
 * Until then, state is stored in localStorage so the heart persists across
 * page views for the same shopper/browser.
 */
class WishlistButton extends HTMLElement {
  constructor() {
    super();
    this.productId = this.dataset.productId;
    this.storageKey = 'shatkona:wishlist';
  }

  connectedCallback() {
    this.render();
    this.addEventListener('click', this.toggle.bind(this));
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.toggle();
      }
    });
  }

  getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(this.storageKey) || '[]');
    } catch (e) {
      return [];
    }
  }

  setWishlist(list) {
    localStorage.setItem(this.storageKey, JSON.stringify(list));
  }

  toggle() {
    const list = this.getWishlist();
    const index = list.indexOf(this.productId);

    if (index > -1) {
      list.splice(index, 1);
      // TODO: call wishlist app's "remove" API here once installed
    } else {
      list.push(this.productId);
      // TODO: call wishlist app's "add" API here once installed
    }

    this.setWishlist(list);
    this.render();

    this.dispatchEvent(
      new CustomEvent('wishlist:updated', {
        bubbles: true,
        detail: { productId: this.productId, list },
      })
    );
  }

  render() {
    const list = this.getWishlist();
    this.classList.toggle('is-active', list.includes(this.productId));
  }
}

customElements.define('wishlist-button', WishlistButton);
